import React from 'react';
import clsx from 'clsx';
import Flex from '../Flex';
import styles from './CheckoutSteps.module.scss';

export type CampaignBannerProps = {
    goBack?: () => void;
    steps: string[];
    activeIndex?: number;
    textColor?: string;
};

export const CheckoutSteps = ({ steps, activeIndex, textColor }: CampaignBannerProps) => {
    return (
        <Flex justifyContent="center" alignItems="center">
            {steps.map((item, index) => {
                const isActive = index === activeIndex;
                const isSpanActive = index === (activeIndex as number) - 1;
                const isDone = index < (activeIndex as number);
                return (
                    <div
                        key={item + index}
                        className={styles.stepContainer}
                        style={{ color: textColor }}
                    >
                        <Flex justifyContent="center" alignItems="center">
                            <div
                                className={clsx(styles.stepItem, {
                                    [styles.active]: isActive,
                                    [styles.done]: isDone,
                                })}
                            >
                                {index + 1}
                            </div>
                            {index !== steps.length - 1 && (
                                <span
                                    className={clsx(styles.stepSpan, {
                                        [styles.active]: isSpanActive,
                                        [styles.done]: isDone,
                                    })}
                                />
                            )}
                            {index === steps.length - 1 && (
                                <span
                                    className={styles.stepSpan}
                                    style={{ visibility: 'hidden' }}
                                />
                            )}
                        </Flex>
                        <div className={styles.stepText}>{item}</div>
                    </div>
                );
            })}
        </Flex>
    );
};
